import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import { useEffect, useRef } from "react"
import CONSTANT from "../../../constant"
import { TTumiorosisakiListGetRes } from "../../../service/master/tumiorosisaki/TTumiorosisaki"

export const NewTumiorosisakiGrid: React.FC<{
  tumiorosisakiList: TTumiorosisakiListGetRes[] | null | undefined
}> = (props) => {
  const gridRef = useRef<wjrGrid.FlexGrid>(null)

  useEffect(() => {
    if (
      gridRef == null ||
      gridRef.current == null ||
      gridRef.current.control == null ||
      props.tumiorosisakiList == null
    )
      return
    const grid = gridRef.current.control as wjcGrid.FlexGrid
    grid.itemsSource = props.tumiorosisakiList
  }, [props.tumiorosisakiList])

  return (
    <wjrGrid.FlexGrid
      className="max-h-12rem"
      {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
      ref={gridRef}>
      <wjrGrid.FlexGridColumn
        width={80}
        binding={"荷主コード"}
        header={"荷主CD"}></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        width={120}
        wordWrap={true}
        binding={"荷主略称1"}
        header={"荷主名"}></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        width={80}
        wordWrap={true}
        binding={"積卸先コード"}
        header={"積卸先CD"}></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        width={180}
        wordWrap={true}
        binding={"積卸先略称"}
        header={"積卸先名"}></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        width={"*"}
        wordWrap={true}
        binding={"積卸先地"}></wjrGrid.FlexGridColumn>
    </wjrGrid.FlexGrid>
  )
}
